import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ConstantMan } from '../../../core/services/constantMan';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { NgModel } from '@angular/forms';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { AppMessagingService } from '../../../core/services/app-messaging.service';
import { HubspotContactUpdateDAO } from '../../../core/services/dao/hubspotContactUpdateDAO';
import * as intlTelInput from 'intl-tel-input';

@Component({
  selector: 'app-customer-phone-number-edit',
  templateUrl: './customer-phone-number-edit.component.html',
  styleUrls: ['./customer-phone-number-edit.component.scss'],
})
export class CustomerPhoneNumberEditComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  phoneCode = '';
  showUpdateForm = false;
  newPhoneNumber = '';
  phoneCodeError = '';
  phoneCodeSuccess = false;
  phoneCodeSent = false;
  subs: Subscription[] = [];

  @Input()
  user: User;

  @Output()
  onSaveClick = new EventEmitter<Partial<User>>();

  constructor(
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private hubspotContactUpdateDAO: HubspotContactUpdateDAO,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.newPhoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (!!value) {
      this._intlTelInput.setNumber(value);
    }
    this.newPhoneNumber = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasValidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return true;
    }
    return false;
  }

  updatePhoneNumberClick(): void {
    this.showUpdateForm = true;
    const intlTelInputInstance = intlTelInput;
    setTimeout(() => {
      this._intlTelInput = intlTelInputInstance(
        this._inputElement.nativeElement,
        { preferredCountries: ['us', 'mx'] },
      );
    }, 100);
  }

  sendVerification(phoneNumberFormItem: NgModel): void {
    if (
      phoneNumberFormItem &&
      phoneNumberFormItem.valid &&
      this.hasValidPhoneNumber()
    ) {
      const sub = this.userDAO
        .sendSmsForPhoneVerification(this.user.id, this.E164PhoneNumber)
        .subscribe((sentVerificationResult) => {
          this.appMessagingService.openSnack(
            'Phone verification code sent successfully',
          );
          console.log('sent successfully');
          this.phoneCodeSent = true;
        });
      this.subs.push(sub);
    }
  }

  confirmPhoneCode(): void {
    const sub = this.userDAO
      .smsConfirmPhone(this.phoneCode, this.user.id)
      .subscribe((phoneConfirmed) => {
        console.log(phoneConfirmed);
        if (phoneConfirmed.success) {
          this.saveUserPhoneNumber({
            phoneNumber: this.E164PhoneNumber,
          });
          this.phoneCodeSuccess = true;
        } else {
          console.log('phone code confirmation failed');
          this.phoneCodeError =
            'Failed to verify phone number, please try again';
        }
      });
    this.subs.push(sub);
  }

  saveUserPhoneNumber(partialUser: Partial<User>): void {
    const sub = this.userDAO
      .updateFromPartial(this.user.id, partialUser)
      .subscribe((data) => {
        this.user.phoneNumber = this.E164PhoneNumber;
        const hubspotUpdateSub = this.hubspotContactUpdateDAO
          .updateContactProperties(this.user.email, this.user.id, {
            phone: this.E164PhoneNumber,
          })
          .subscribe();
        this.subs.push(hubspotUpdateSub);
        this.resetComponentState();
        this.appMessagingService.openSnack('Phone number updated');
      });
    this.subs.push(sub);
  }

  resetComponentState(): void {
    this.phoneCode = '';
    this.newPhoneNumber = '';
    this.phoneCodeError = '';
    this.showUpdateForm = false;
    this.phoneCodeSuccess = false;
    this.phoneCodeSent = false;
  }
}
